import React, { useContext } from 'react'

import { Route, Redirect } from "react-router-dom"

import { UserContext } from '../context/userContext'


const PrivateRouter = ({ children, ...rest }) => {

  const { user } = useContext(UserContext);

  return (

    <Route
      {...rest}
      render={({ location }) => (
        user.loggedIn ? children :
          <Redirect
            to={{
              pathname: `/login`,
              state: { from: location }
            }}
          />
      )
      }
    />

  )
}
export default PrivateRouter
